import { union } from "lodash-es";
import { createReducer } from "typesafe-actions";

import { Lead } from "@mapmycustomers/shared/types/entity";

import {
  Actions,
  addLeadsToSelection,
  clearLeadSelection,
  setHighlightedLeads,
  setLeadFinderResultsVisible,
  setSelectedLeads,
  toggleLeadSelection,
} from "../actions";

export interface RouteLeadFinderState {
  highlightedLeadPlaceIds: Set<Lead["place_id"]>;
  resultsVisible: boolean;
  selectedLeadPlaceIds: Array<Lead["place_id"]>;
}

export const routeLeadFinderInitialState: RouteLeadFinderState = {
  highlightedLeadPlaceIds: new Set(),
  resultsVisible: false,
  selectedLeadPlaceIds: [],
};

const routeLeadFinder = createReducer<RouteLeadFinderState, Actions>(routeLeadFinderInitialState)
  .handleAction(toggleLeadSelection, (state, { payload }) => ({
    ...state,
    selectedLeadPlaceIds: state.selectedLeadPlaceIds.includes(payload)
      ? state.selectedLeadPlaceIds.filter((placeId) => placeId !== payload)
      : [...state.selectedLeadPlaceIds, payload],
  }))
  .handleAction(addLeadsToSelection, (state, { payload }) => ({
    ...state,
    selectedLeadPlaceIds: union(state.selectedLeadPlaceIds, payload),
  }))
  .handleAction(clearLeadSelection, (state) => ({ ...state, selectedLeadPlaceIds: [] }))
  .handleAction(setSelectedLeads, (state, { payload }) => ({
    ...state,
    selectedLeadPlaceIds: payload,
  }))
  .handleAction(setHighlightedLeads, (state, { payload }) => ({
    ...state,
    highlightedLeadPlaceIds: payload,
  }))
  .handleAction(setLeadFinderResultsVisible, (state, { payload }) => ({
    ...state,
    highlightedLeadPlaceIds: payload ? state.highlightedLeadPlaceIds : new Set(),
    resultsVisible: payload,
    selectedLeadPlaceIds: payload ? state.selectedLeadPlaceIds : [],
  }));

export default routeLeadFinder;
